<template>
  <a-modal v-model="visible" :title="title" :destroyOnClose="true">
    <a-form-model
      ref="addonForm"
      :model="addon"
      :rules="rules"
      layout="vertical"
    >
      <a-row :gutter="16">
        <a-col :span="24" v-if="mode == 'create'">
          <a-form-model-item label="Id" prop="id">
            <a-input-number
              placeholder="Id"
              v-model="addon.id"
              class="w-100"
            ></a-input-number>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Name" prop="name">
            <a-input placeholder="Name" v-model="addon.name" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Billing Type" prop="addonBillingType">
            <a-select :disabled="mode !== 'create'"
              v-model="addon.addonBillingType"
              placeholder="billing type"
              style="width: 100%"
            >
              <a-select-option
                v-for="type in addonBillingTypes"
                :key="type.id"
                :value="type.id"
              >
                {{ type.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Display Unit" prop="displayUnit">
            <a-select
              v-model="addon.displayUnit"
              placeholder="Display Unit"
              style="width: 100%"
              :disabled="addon.addonBillingType === 1"
            >
              <a-select-option
                v-for="type in units"
                :key="type.id"
                :value="type.id"
              >
                {{ type.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Calculate Unit" prop="calculateUnit">
            <a-select
              v-model="addon.calculateUnit"
              placeholder="Calculate Unit"
              style="width: 100%"
              :disabled="addon.addonBillingType === 1"
            >
              <a-select-option
                v-for="type in units"
                :key="type.id"
                :value="type.id"
              >
                {{ type.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="Unit Price" prop="unitPrice">
            <a-input-number
              class="width-100"
              placeholder="Unit Price"
              :min="0"
              v-model="addon.unitPrice"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item
            v-if="tinymceEditorLoading"
            label="Agreement"
            prop="agreement"
          >
            <editor
              api-key="lriv06w5l8uywsudqf3xk1fyeptapcz5wwhbz8iwlywuzhm9"
              :init="{
                height: '200',
                menubar: false,
                placeholder: 'Agreement',
                plugins: [
                  'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern noneditable help charmap quickbars emoticons',
                ],
                toolbar:
                  'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl |',
              }"
              v-model="addon.agreement"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="Business" prop="businessId">
            <a-select
              placeholder="Business"
              v-model="addon.businessId"
              style="width: 100%"
            >
              <a-select-option
                v-for="business in businesses"
                :key="business.id"
                :value="business.id"
              >
                {{ business.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Is Active" prop="isActive">
            <a-switch v-model="addon.isActive" />
          </a-form-model-item>
        </a-col>
      </a-row>      
      <a-row :gutter="16">
        <a-tooltip  title="You can allow/prevent sending notification after update the addon price.">
        <a-icon type="info-circle" />
        </a-tooltip>
        <a-col :span="8">
          <a-form-model-item label="Send Notification" prop="sendNotification">
            <a-switch v-model="addon.sendNotification" />
          </a-form-model-item>
          <a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="save" :loading="isSaving">{{
        actionButtonText
      }}</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
import { addonsMutations } from "../../Store/store";
import Editor from "@tinymce/tinymce-vue";
export default {
  props: {
    value: Boolean,
    mode: String,
    addon: {
      type: Object,
      defualt: () => ({}),
    },
    businesses: Array,
    addonBillingTypes: Array,
    units: Array,
  },
  data() {
    return {
      rules: {
        id: [{ required: true, message: "Please input Id", trigger: "blur" }],
        name: [
          {
            required: true,
            message: "Please input Addon Name",
            trigger: "blur",
          },
        ],
        unitPrice: [
          {
            required: true,
            message: "Please input unit price",
            trigger: "blur",
          },
        ],
        displayUnit: [
          {
            required: true,
            message: "Please input unit that will be shown for clients",
            trigger: "blur",
          },
        ],
        calculateUnit: [
          {
            required: true,
            message: "Please input unit that will be used for cost calculating",
            trigger: "blur",
          },
        ],
        addonBillingType: [
          {
            required: true,
            message: "Please pick a billing type",
            trigger: "change",
          },
        ],
        businessId: [
          {
            required: true,
            message: "Please pick a Business",
            trigger: "change",
          },
        ],
      },
      isSaving: false,
      tinymceEditorLoading: false,
      payAsYouGoDisplayUnit: "",
      payAsYouGoCalculateUnit: "",
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    title() {
      return this.mode == "create" ? "New Addon" : "Edit addon";
    },
    actionButtonText() {
      return this.mode == "create" ? "Save" : "Update";
    },
  },
  watch: {
    addon: function (newVal) {
      if (newVal) {
        this.tinymceEditorLoading = false;
        this.$nextTick(() => {
          this.tinymceEditorLoading = true;
        });
      }
    },
    "addon.addonBillingType": function (newVal, oldVal) {
      if (newVal == 1) {
        this.addon.displayUnit = "Month";
        this.addon.calculateUnit = "Day";
        }
      if (oldVal == 1 && newVal == 2)
      { 
        this.addon.displayUnit = this.payAsYouGoDisplayUnit;
        this.addon.calculateUnit = this.payAsYouGoCalculateUnit;
        }
    },
    value: function (val) {
      if (val) {
        this.payAsYouGoDisplayUnit = this.addon.displayUnit;
        this.payAsYouGoCalculateUnit = this.addon.calculateUnit;
      }
    },
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    save() {
      this.$refs.addonForm.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;

          var changedAddon = {
            id: this.addon.id,
            name: this.addon.name,
            unitPrice: this.addon.unitPrice,
            calculateUnit: this.addon.calculateUnit,
            displayUnit: this.addon.displayUnit,
            addonBillingType: this.addon.addonBillingType,
            businessId: this.addon.businessId,
            isActive: this.addon.isActive,
            agreement: this.addon.agreement,
            sendNotification : this.addon.sendNotification
          };

          try {
            if (this.mode == "create") {
              await addonsMutations.addAddon(changedAddon);
            } else {
              await addonsMutations.updateAddon(changedAddon);
            }
            this.visible = false;
          } catch (error) {
            var self = this;
            if (
              error &&
              error.response &&
              error.response.data &&
              error.response.data.errors &&
              error.response.data.errors.some((e) => e.propertyName)
            ) {
              var errors = error.response.data.errors;
              errors.forEach((e) => {
                self.$refs.addonForm.fields
                  .filter((field) => field.prop === e.propertyName)
                  .forEach((field) => {
                    field.validateState = "error";
                    field.validateMessage = e.errorMessage;
                  });
              });
            } else {
              this.showError(error);
              
            }
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
  },
  components: {
    editor: Editor,
  },
};
</script>

